// extracted by mini-css-extract-plugin
module.exports = {"backLink":"Breadcrumb_backLink__3QHkY"};